module.exports = __webpack_public_path__ + "static/media/Afaq_14001_g.7f40a33b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Afaq_14001_g.png
// module id = 1734
// module chunks = 0